import { http } from '../../utils/http'

export const CRMBASE = window.$envUtils('VUE_APP_CRM_SERVICE')

// 删除标签
export const delLabel = (data) => {
  return new Promise((resolve, reject) => {
    http.delete(`${CRMBASE}/label/`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 查询全部标签
export const getPageLabelList = (data) => {
  return new Promise((resolve, reject) => {
    http.post(`${CRMBASE}/label/listPageLabels`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 保存标签
export const saveTag = (data) => {
  return new Promise((resolve, reject) => {
    http.post(`${CRMBASE}/label/`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 编辑标签
export const updateTag = (data) => {
  return new Promise((resolve, reject) => {
    http.put(`${CRMBASE}/label/`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}
